import { APICore } from './apiCore';

const api = new APICore();

export function dashboardOutlets() {
    return api.get('/dashboard/outlets');
}
